export const NUTRICIA_EORI = 'GB436975115000';

/** Display key for DIRFT (Danone removed from naming — CABS-2811 follow-up). */
export const DIRFT_NAME = 'DIRFT';

/**
 * True if the port label is DIRFT (matches "DIRFT" or legacy "DIRFT (…)" from API).
 * @param {string | null | undefined} label
 */
export const isDirftPortLabel = (label) => {
  if (label == null || label === '') return false;
  const s = String(label).trim().toUpperCase();
  return s === 'DIRFT' || s.startsWith('DIRFT ');
};
